"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// src/components/table/OptionMenu.tsx
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("@mui/material/Button"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var KeyboardArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDown"));
var StyledMenu = (0, styles_1.styled)(function (props) { return (react_1.default.createElement(Menu_1.default, __assign({ elevation: 0, anchorOrigin: { vertical: "bottom", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "right" } }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiPaper-root": {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            boxShadow: theme.shadows[5],
            "& .MuiMenuItem-root": {
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                    marginRight: theme.spacing(1.5),
                },
            },
        },
    });
});
var OptionMenu = function (_a) {
    var optionsObject = _a.optionsObject, row = _a.row;
    var _b = react_1.default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Button_1.default, { onClick: handleClick, endIcon: react_1.default.createElement(KeyboardArrowDown_1.default, null) }, "Options"),
        react_1.default.createElement(StyledMenu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose }, optionsObject.map(function (option, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, onClick: function () {
                option.function(row);
                handleClose();
            } }, option.label)); }))));
};
exports.default = OptionMenu;
